import { MEDIA } from "@brg/ui";
import { CoreContainer } from "core";
import styled from "styled-components";

export const Container = styled(CoreContainer)`
  display: flex;
  flex-flow: column;
  gap: 20px;
  .search-bar-wrapper {
    max-height: 20px;
  }

  @media ${MEDIA.TABLET} {
    .grid-w {
      padding-top: 16px;
    }
  }

  @media ${MEDIA.MOBILE} {
    .grid-w {
      padding-top: 0px;
    }
  }
`;

export const GapContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;import { MEDIA } from "@brg/ui";
import { CoreContainer } from "core";
import styled from "styled-components";

export const Container = styled(CoreContainer)`
  display: flex;
  flex-flow: column;
  gap: 20px;
  .search-bar-wrapper {
    max-height: 20px;
  }

  @media ${MEDIA.TABLET} {
    .grid-w {
      padding-top: 16px;
    }
  }

  @media ${MEDIA.MOBILE} {
    .grid-w {
      padding-top: 0px;
    }
  }
`;

export const GapContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;